import { lazy } from 'react';

const DashboardRoutes = [
  {
    path: "/chat",
    component: lazy(() => import("../views/pages/dashboardDetails")),
    exact: true,
  },
];

export default DashboardRoutes;
